const bulkPanelBorderColor = (theme) => theme.palette.primary.light || theme.palette.divider;

const bulkSelectStyles = (theme) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.primary.paleGrey,
    borderRadius: theme.shape.borderRadius || 4,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider,
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.text.secondary,
  },
  '& .MuiSelect-select': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
});

export default (theme) => ({
  bulkBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1.5),
    border: `1px solid ${bulkPanelBorderColor(theme)}`,
    borderRadius: theme.shape.borderRadius || 8,
    backgroundColor: theme.palette.primary.paleBlue || theme.palette.colors?.blue?.pale,
  },
  selectionLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  selectionSummary: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  clearSelection: {
    border: 'none',
    background: 'none',
    padding: 0,
    color: theme.palette.text.secondary,
    textDecoration: 'underline',
    cursor: 'pointer',
    font: 'inherit',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  selectionActions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  card: {
    border: `1px solid ${bulkPanelBorderColor(theme)}`,
    borderRadius: theme.shape.borderRadius || 8,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.paleBlue || theme.palette.colors?.blue?.pale,
  },
  headerText: {
    flex: 1,
    minWidth: 0,
  },
  headerTitle: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  headerSubtitle: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  closeButton: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5),
    flexShrink: 0,
  },
  body: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
  },
  bodyLoading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  sameRoleField: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
  },
  sameRoleLabel: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  sameRoleSelect: {
    minWidth: 280,
    maxWidth: 320,
    ...bulkSelectStyles(theme),
  },
  hint: {
    marginTop: theme.spacing(1),
  },
  differentRoleList: {
    display: 'flex',
    flexDirection: 'column',
  },
  differentRoleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.25, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
    '&:first-child': {
      paddingTop: 0,
    },
  },
  differentRoleRowChanged: {
    backgroundColor: theme.palette.action.hover,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  facilityInfo: {
    flex: '0 1 220px',
    minWidth: 120,
    maxWidth: 240,
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
      maxWidth: 'none',
    },
  },
  facilityName: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  },
  roleFieldGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  roleSelect: {
    width: 220,
    flexShrink: 0,
    ...bulkSelectStyles(theme),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  currentRole: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2, 2),
    backgroundColor: theme.palette.common.white,
  },
});
